// These labels present persisted server decisions. Never derive authority from a live listing.
export const modeLabel = (mode, ct) => ({
  PROVIDER_DROPSHIPPING: ct("modeDs"),
  PROVIDER_STOCK_SELLER_OWNED: ct("modeStore"),
  SELLER_STOCK: ct("modeShip"),
}[mode] || "—");

export const actorLabel = (actor, ot) => ({ PROVIDER: ot("provider"), SELLER: ot("seller"), IN_TRANSIT: ot("statusShipped") }[actor] || "—");

export const statusLabel = (status, ot) => ({
  "Not processed": ot("statusNotProcessed"), Processing: ot("statusProcessing"),
  Shipped: ot("statusShipped"), Delivered: ot("statusDelivered"), Cancelled: ot("statusCancelled"),
  "Return or replace": ot("statusReturn"), "Return Back": ot("statusReturned"), Replace: ot("statusReplace"),
  pending: ot("pending"), confirmed: ot("confirmed"), shipped: ot("statusShipped"), delivered: ot("statusDelivered"),
  cancelled: ot("statusCancelled"), rejected: ot("rejected"), paid: ot("paid"), captured: ot("paid"),
  authorized: ot("authorized"), unpaid: ot("unpaid"),
}[status] || status || "—");

export const safeTrackingUrl = (value) => {
  try { const url = new URL(value); return ["http:", "https:"].includes(url.protocol) ? url.href : ""; }
  catch { return ""; }
};

export const isProviderFulfilled = (product) => product?.dropshippingIn?.fulfillmentOwner === "PROVIDER";
